
const Errors = {
    1: { message: 'Generic Error', detail: 'Errore Generico' },
    2: { message: 'Unauthorized', detail: 'Non Autorizzato' },
    3: { message: 'Not Found', detail: 'Non Trovato' },
    4: { message: 'Upload Error', detail: 'Errore nel caricamento' },
    5: { message: 'Already Exists', detail: 'Già Esistente' },
    6: { message: 'Invalid Credentials', detail: 'Credenziali non valide' },
    7: { message: 'Cannot Access', detail: 'Accesso Negato' },
    8: { message: 'Stripe Error', detail: 'Errore Stripe' },
    9: { message: 'Profile Suspended', detail: 'Profilo Sospeso' },
    10: { message: 'Account Locked', detail: 'Account Bloccato' },
    11: { message: 'Missing Field', detail: 'Campo Mancante' },
    12: { message: 'Profile Not Found', detail: 'Profilo Non Trovato' },
    13: { message: 'Teacher Not Found', detail: 'Insegnante Non Trovato' },
    14: { message: 'Verification Email Not Sent', detail: 'Email di verifica non inviata' },
    15: { message: 'Password Reset Email Not Sent', detail: 'Email di reset password non inviata' },
    16: { message: 'Hosting Error', detail: 'Errore dell\' hosting' },
    17: { message: 'Application Not Found', detail: 'Candidatura non trovata' },
    18: { message: 'Mail Error', detail: 'Errore nell\'invio della mail' },
    19: { message: 'Invalid Field', detail: 'Campo non valido' },
    20: { message: 'Subscription Error', detail: 'Errore di iscrizione' },
    21: { message: 'Expired', detail: 'Scaduto' },
    22: { message: 'Timeout', detail: 'Timeout' },

}

export function errorDetailText(value) {
    if (typeof value === 'string') return value;
    if (Array.isArray(value)) return value.map(item => {
        const path = Array.isArray(item?.loc) ? item.loc.filter(part => part !== 'body').join(' → ') : '';
        const message = errorDetailText(item?.msg ?? item);
        return path ? `${path}: ${message}` : message;
    }).filter(Boolean).join('\n');
    if (value && typeof value === 'object') return errorDetailText(value.detail ?? value.message ?? value.msg);
    return '';
}

export function mapServerError(error) {
    const mappedError = Errors[error?.code];
    if (mappedError) return mappedError;
    return {
        message: errorDetailText(error?.message) || 'Operazione non riuscita',
        detail: errorDetailText(error?.detail ?? error) || 'Riprova.',
    };
}
